import { casinoRouteForLobby } from '../data/casinoData';
import { DEPLOY_ASSET_VERSION } from '../utils/assetCache';
import { FOOTER_PROVIDERS } from './footerProvidersData';
import './footerProviderGrid.css';

function logoSrc(path) {
  if (!path) return path;
  const v = DEPLOY_ASSET_VERSION || '1';
  return path.includes('?') ? `${path}&v=${encodeURIComponent(v)}` : `${path}?v=${encodeURIComponent(v)}`;
}

const ALL_GAMES_TAB_ID = '496';

const LIVE_HINTS = ['evolution', 'ezugi', 'pragmaticplaylive', 'live', 'onair', 'realdealer'];
const FAST_HINTS = ['smartsoft', 'spribe', 'galaxsys'];

function lobbyForTitle(title = '') {
  const key = String(title).toLowerCase();
  if (LIVE_HINTS.some((h) => key.includes(h))) return 'live';
  if (FAST_HINTS.some((h) => key.includes(h))) return 'fast';
  return 'slots';
}

export default function FooterProviderGrid({ onNavigate }) {
  const providers = FOOTER_PROVIDERS;
  if (!providers.length) return null;

  const onClick = (event, provider) => {
    if (!onNavigate) return;
    event.preventDefault();
    const route = casinoRouteForLobby(lobbyForTitle(provider.title));
    onNavigate('casino', {
      casinoTabId: ALL_GAMES_TAB_ID,
      casinoLobbyId: route.casinoLobbyId,
      casinoProvider: provider.title,
    });
  };

  return (
    <div
      className="footer-providers"
      style={{ '--provider-count': providers.length }}
    >
      <div className="footer-providers__grid">
        {providers.map((provider) => (
          <a
            key={provider.slug}
            href="/tr/casino"
            className="footer-providers__item"
            title={provider.title}
            onClick={(e) => onClick(e, provider)}
          >
            <img
              className="footer-providers__logo"
              src={logoSrc(provider.logo)}
              alt={`${provider.title} oyunlarını VurgunBet üzerinde oynayın`}
              sizes="150px"
              width={32}
              height={32}
              loading="lazy"
              decoding="async"
            />
          </a>
        ))}
      </div>
    </div>
  );
}
